export default "__VITE_ASSET__d83f616e__"